import { useFormik } from "formik";
import { useState } from "react";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { NuDate, NuInput, NuTextArea } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import { statusList, TaskModuleList } from "../../../assets/data/CountryMini";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  id,
  value,
}) {
  const { isCreateLoading, addData } = useAddData();
  const [createNew, setCreateNew] = useState({
    task_id: "",
    title: "",
    comment: "",
    completion_date: value.startStr,
    reminder_date: value.startStr,
    status: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      addData({
        url: `/Calender-Management/standard/${id}`,
        value: value,
        resetForm: resetForm,
        onClose: onClose,
        getData: refreshData,
      });
    },
  });

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <FormikSelectTwo
                formik={formik}
                name="task_id"
                label="Task"
                width="w-1/2"
                placeholder="Select Task"
                Options={TaskModuleList}
                zindex={12}
              />
              <NuInput
                formik={formik}
                name="title"
                label="Title"
                width="w-1/2"
                placeholder="Enter Title"
              />
              <NuTextArea
                formik={formik}
                name="comment"
                label="Comment"
                width="w-full"
                placeholder="Enter Comment"
              />
              <NuDate
                name="completion_date"
                label="Completion Date"
                width="w-1/2"
                formik={formik}
              />
              <NuDate
                name="reminder_date"
                label="Reminder Date"
                width="w-1/2"
                formik={formik}
              />
              <FormikSelectTwo
                formik={formik}
                name="status"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={statusList}
                zindex={12}
              />

              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading}
                />
                <SubmitButton isLoading={isCreateLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
